import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ShoppingBag, Heart, Star, ChevronRight, ChevronLeft, Plus, Minus, X, ShoppingCart, Truck, Shield, RefreshCw, Eye, Flame, Clock, Check, ArrowRight } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ASSET = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/assets/file/${id}.png`;

const COLLECTIONS = [
  { id: 'all', label: 'All' },
  { id: 'smithers', label: 'SMITHERS XI' },
  { id: 'creators', label: "CREATOR'S AGENT" },
  { id: 'quadra', label: 'QUADRA CORE' },
  { id: 'stake', label: "CREATOR'S STAKE" },
];

const HERO_BANNER = 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/xqhu2gfz_image_d14e4832-084d-4197-a7f2-8a135f99a95b%20%281%29.png';

const PRODUCTS = [
  // === SMITHERS XI COLLECTION ===
  {
    id: 'sxi-hoodie-set',
    name: 'SMITHERS XI Hoodie & Jogger Set',
    collection: 'smithers',
    price: 189.00,
    originalPrice: 249.00,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/mxhm473v_image_6759c3c9-5cda-46b9-9695-c6c803d551b8.png',
    description: 'Premium heavyweight fleece set with gold embroidered SMITHERS XI branding. SXI woven label detail.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Obsidian Black', hex: '#0D0D0D' }],
    badge: 'BEST SELLER',
    badgeColor: '#F59E0B',
    rating: 4.9,
    reviews: 127,
    stock: 14,
    category: 'Sets',
  },
  {
    id: 'sxi-speedo',
    name: 'SMITHERS XI Competition Speedo',
    collection: 'smithers',
    price: 59.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/inne0r60_image_e33e184d-0074-4b3a-83ea-3330010a976d.png',
    description: 'Navy competition-cut swim brief with gold SMITHERS XI branding. Chlorine-resistant, quick-dry fabric.',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: [{ name: 'Navy', hex: '#1a1a4e' }],
    badge: 'NEW',
    badgeColor: '#00F0FF',
    rating: 4.8,
    reviews: 43,
    stock: 8,
    category: 'Swimwear',
  },
  {
    id: 'sxi-coral-brief',
    name: 'SMITHERS XI Swim Brief — Coral',
    collection: 'smithers',
    price: 59.00,
    originalPrice: null,
    image: ASSET('ea87cc5d-af60-4fa7-9356-6d660e4099d7'),
    description: 'Peachy-coral swim brief with gold SMITHERS XI lettering. Quick-dry performance fabric with sheen finish.',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: [{ name: 'Coral', hex: '#F08080' }],
    badge: 'NEW',
    badgeColor: '#00F0FF',
    rating: 4.8,
    reviews: 29,
    stock: 10,
    category: 'Swimwear',
  },
  {
    id: 'sxi-boxer-black',
    name: 'SMITHERS XI Luxury Boxer Brief — Onyx',
    collection: 'smithers',
    price: 45.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/v1m3uc2c_image_0526056b-b0d2-4079-9cb8-0ca91ae3893f.png',
    description: 'Ultra-soft modal boxer brief with gold S monogram and SMITHERS XI waistband. Second-skin fit.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Onyx Black', hex: '#111' }],
    badge: 'LIMITED',
    badgeColor: '#FF00E5',
    rating: 5.0,
    reviews: 89,
    stock: 6,
    category: 'Underwear',
  },
  {
    id: 'sxi-boxer-navy',
    name: 'SMITHERS XI Luxury Boxer Brief — Midnight',
    collection: 'smithers',
    price: 45.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/ej6obn6c_image_b8429d08-0889-4307-ad02-8c9ca0921539.png',
    description: 'Premium modal boxer brief in midnight navy. Gold embroidered S monogram and SMITHERS XI waistband.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Midnight Navy', hex: '#1a1a3e' }],
    badge: null,
    badgeColor: null,
    rating: 4.9,
    reviews: 64,
    stock: 11,
    category: 'Underwear',
  },
  {
    id: 'sxi-brief-charcoal',
    name: 'SMITHERS XI Classic Brief — Slate',
    collection: 'smithers',
    price: 39.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/3fd7hj97_image_db46598d-cdc3-41da-8ab9-c87dcbf1f7f8.png',
    description: 'Classic-cut brief in charcoal slate. Gold S monogram with SMITHERS XI waistband on natural stone.',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: [{ name: 'Charcoal Slate', hex: '#333' }],
    badge: 'EXCLUSIVE',
    badgeColor: '#8B5CF6',
    rating: 4.8,
    reviews: 52,
    stock: 7,
    category: 'Underwear',
  },
  {
    id: 'sxi-brief-ivory',
    name: 'SMITHERS XI Classic Brief — Ivory',
    collection: 'smithers',
    price: 39.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/2w0gemeu_image_4a8f2c5f-9bd7-4d93-846c-b19d6964ef22.png',
    description: 'Luxury cotton brief in ivory cream. Gold S monogram, SMITHERS XI waistband. Marble-finish presentation.',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: [{ name: 'Ivory Cream', hex: '#F5F0E8' }],
    badge: 'NEW',
    badgeColor: '#00F0FF',
    rating: 4.9,
    reviews: 31,
    stock: 5,
    category: 'Underwear',
  },
  {
    id: 'sxi-brief-black',
    name: 'SMITHERS XI Classic Brief — Black',
    collection: 'smithers',
    price: 39.00,
    originalPrice: null,
    image: ASSET('c8993790-7f2b-4b38-af2b-527575f7bea1'),
    description: 'Classic-cut brief in black with embossed SMITHERS XI waistband. Premium softness and all-day comfort.',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: [{ name: 'Black', hex: '#111' }],
    badge: null,
    badgeColor: null,
    rating: 4.9,
    reviews: 47,
    stock: 15,
    category: 'Underwear',
  },
  {
    id: 'sxi-brief-grey',
    name: 'SMITHERS XI Classic Brief — Graphite',
    collection: 'smithers',
    price: 39.00,
    originalPrice: null,
    image: ASSET('2fcda6d2-30bc-4c05-8861-9c0409277b31'),
    description: 'Classic-cut brief in dark graphite grey. Gold S monogram on SMITHERS XI waistband. Ultra-soft fabric.',
    sizes: ['S', 'M', 'L', 'XL'],
    colors: [{ name: 'Graphite', hex: '#444' }],
    badge: null,
    badgeColor: null,
    rating: 4.8,
    reviews: 38,
    stock: 12,
    category: 'Underwear',
  },
  {
    id: 'sxi-longsleeve',
    name: 'SMITHERS XI Heritage Long Sleeve',
    collection: 'smithers',
    price: 69.00,
    originalPrice: 89.00,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/igkuu8nl_image_cb0f0432-59ff-4b9e-ab81-58f591d8f8f4.png',
    description: 'Garment-dyed heavyweight cotton long sleeve with chest SMITHERS XI arch logo and SXI hem label.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Vintage Black', hex: '#1A1A1A' }],
    badge: 'SELLING FAST',
    badgeColor: '#DC2626',
    rating: 4.9,
    reviews: 178,
    stock: 10,
    category: 'Long Sleeves',
  },
  {
    id: 'sxi-winged-s-tee',
    name: 'SMITHERS XI Winged S Tee',
    collection: 'smithers',
    price: 49.00,
    originalPrice: null,
    image: ASSET('f6326aea-2f59-46ef-9a9f-6d01cadaaa61'),
    description: 'Premium black tee with gold metallic winged S emblem and SMITHERS XI typography. Statement piece.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Black', hex: '#111' }],
    badge: 'ICONIC',
    badgeColor: '#D4AF37',
    rating: 5.0,
    reviews: 94,
    stock: 18,
    category: 'T-Shirts',
  },
  {
    id: 'sxi-quote-tee',
    name: '"Yeah, He Can Do That" Tee',
    collection: 'smithers',
    price: 44.00,
    originalPrice: null,
    image: ASSET('49ee1e12-e8b8-4966-b40a-add2af8a47ed'),
    description: '"Yeah, he can do that. And that too. And that too. And you too." SMITHERS XI signature quote tee.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Black', hex: '#111' }],
    badge: 'FAN FAVORITE',
    badgeColor: '#F59E0B',
    rating: 4.9,
    reviews: 203,
    stock: 22,
    category: 'T-Shirts',
  },
  {
    id: 'sxi-butler-tee',
    name: '"My Butler\'s Hotter Than Yours" Tee',
    collection: 'smithers',
    price: 44.00,
    originalPrice: null,
    image: ASSET('ad0f0b5c-7a2f-4e1c-9506-c46f0ff900e0'),
    description: 'Bold statement tee — "My Butler\'s Hotter Than Yours" in gold script. SMITHERS XI branding.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Black', hex: '#111' }],
    badge: 'TRENDING',
    badgeColor: '#FF00E5',
    rating: 4.9,
    reviews: 167,
    stock: 16,
    category: 'T-Shirts',
  },
  {
    id: 'sxi-crewneck',
    name: 'SMITHERS XI Crewneck Sweatshirt',
    collection: 'smithers',
    price: 89.00,
    originalPrice: null,
    image: ASSET('46100abe-4353-49f5-af18-19d6d85d53e7'),
    description: 'Navy blue crewneck sweatshirt with gold embroidered SMITHERS XI text. Premium heavyweight knit.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Navy', hex: '#1a1a3e' }],
    badge: null,
    badgeColor: null,
    rating: 4.8,
    reviews: 76,
    stock: 13,
    category: 'Hoodies',
  },
  {
    id: 'sxi-joggers-grey',
    name: 'SMITHERS XI Joggers — Heather Grey',
    collection: 'smithers',
    price: 89.00,
    originalPrice: null,
    image: ASSET('0c936136-11e6-48cd-972d-deff016cbaf8'),
    description: 'Heather grey tapered joggers with gold SMITHERS XI embroidery. Drawstring waist, cuffed ankles.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Heather Grey', hex: '#888' }],
    badge: 'NEW',
    badgeColor: '#00F0FF',
    rating: 4.7,
    reviews: 33,
    stock: 20,
    category: 'Joggers',
  },
  {
    id: 'sxi-hoodie',
    name: 'SMITHERS XI Signature Hoodie',
    collection: 'smithers',
    price: 129.00,
    originalPrice: 159.00,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/mxhm473v_image_6759c3c9-5cda-46b9-9695-c6c803d551b8.png',
    description: 'Standalone premium hoodie from the XI collection. Gold thread embroidery, SXI woven label on cuff.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Obsidian Black', hex: '#0D0D0D' }],
    badge: null,
    badgeColor: null,
    rating: 4.9,
    reviews: 201,
    stock: 9,
    category: 'Hoodies',
  },
  {
    id: 'sxi-joggers',
    name: 'SMITHERS XI Joggers — Black',
    collection: 'smithers',
    price: 89.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/mxhm473v_image_6759c3c9-5cda-46b9-9695-c6c803d551b8.png',
    description: 'Tapered fit joggers with SMITHERS XI leg branding. Zippered pockets, premium fleece interior.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Obsidian Black', hex: '#0D0D0D' }],
    badge: null,
    badgeColor: null,
    rating: 4.8,
    reviews: 87,
    stock: 18,
    category: 'Joggers',
  },
  {
    id: 'sxi-boxer-stealth',
    name: 'SMITHERS XI Stealth Boxer Brief',
    collection: 'smithers',
    price: 55.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/32bxdigk_image_0aeb980d-e809-4c4a-b953-e69e6ce091ef.png',
    description: 'Tonal black-on-black luxury boxer brief. SMITHERS XI embossed branding. Presented with SXI authentication card.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Stealth Black', hex: '#0A0A0A' }],
    badge: 'EXCLUSIVE',
    badgeColor: '#8B5CF6',
    rating: 5.0,
    reviews: 42,
    stock: 4,
    category: 'Underwear',
  },
  {
    id: 'sxi-boxer-white',
    name: 'SMITHERS XI Luxury Boxer Brief — Pearl',
    collection: 'smithers',
    price: 49.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/v2pgocr3_image_20a809a4-206e-4aa7-a30a-a1e230ee9abc.png',
    description: 'Premium white boxer brief with gold S monogram and SMITHERS XI waistband. Crisp, clean luxury.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Pearl White', hex: '#F8F8F8' }],
    badge: 'NEW',
    badgeColor: '#00F0FF',
    rating: 4.9,
    reviews: 28,
    stock: 12,
    category: 'Underwear',
  },
  {
    id: 'sxi-muscle-tee',
    name: 'SMITHERS XI Performance Tank',
    collection: 'smithers',
    price: 49.00,
    originalPrice: 65.00,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/3apuhlk6_image_890b3477-1800-4b63-a482-c0b187b3dcca.png',
    description: 'Moisture-wicking sleeveless tank with bold gold SMITHERS XI chest print. SXI hem tag. Gym to street.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Matte Black', hex: '#111' }],
    badge: 'SELLING FAST',
    badgeColor: '#DC2626',
    rating: 4.8,
    reviews: 134,
    stock: 7,
    category: 'Tanks',
  },
  {
    id: 'sxi-beanie',
    name: 'SXI Ribbed Beanie',
    collection: 'smithers',
    price: 35.00,
    originalPrice: null,
    image: ASSET('5d10e24c-b471-4029-b0b6-2beed64c8c55'),
    description: 'Chunky ribbed knit beanie with gold SXI embroidery on fold. One size fits all.',
    sizes: ['ONE SIZE'],
    colors: [{ name: 'Black', hex: '#111' }],
    badge: null,
    badgeColor: null,
    rating: 4.9,
    reviews: 215,
    stock: 22,
    category: 'Accessories',
  },
  {
    id: 'sxi-dad-cap',
    name: 'SMITHERS XI Winged S Dad Cap',
    collection: 'smithers',
    price: 42.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/i6s0j9uc_image_a1480de7-a237-454c-a668-16859931c63b.png',
    description: 'Washed cotton dad cap with gold winged S emblem on back, SXI side branding. Gold metal buckle closure.',
    sizes: ['ONE SIZE'],
    colors: [{ name: 'Washed Black', hex: '#1A1A1A' }],
    badge: 'BEST SELLER',
    badgeColor: '#F59E0B',
    rating: 4.9,
    reviews: 312,
    stock: 15,
    category: 'Accessories',
  },
  // === QUADRA CORE COLLECTION ===
  {
    id: 'qc-signature-tee',
    name: 'QUADRA Core OS Signature Tee',
    collection: 'quadra',
    price: 49.00,
    originalPrice: null,
    image: ASSET('6b3f9a51-87e1-416b-bed8-1625b097d3af'),
    description: 'Black premium tee with rainbow holographic QUADRA Core OS diamond logo. "Quantum Unified Autonomous Decision & Reasoning Agent" tagline.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Black', hex: '#111' }],
    badge: 'NEW',
    badgeColor: '#00F0FF',
    rating: 4.9,
    reviews: 56,
    stock: 20,
    category: 'T-Shirts',
  },
  {
    id: 'qc-engineer-tee',
    name: 'QUADRA Core ENGINEER Tee',
    collection: 'quadra',
    price: 49.00,
    originalPrice: null,
    image: ASSET('873f15a9-1661-40f3-a1c5-6b14e7ef342f'),
    description: 'Black tee featuring the QUADRA Core ENGINEER archetype in futuristic armor with blueprints. Gold and purple design.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Black', hex: '#111' }],
    badge: null,
    badgeColor: null,
    rating: 4.8,
    reviews: 41,
    stock: 16,
    category: 'T-Shirts',
  },
  // === CREATOR'S AGENT COLLECTION ===
  {
    id: 'tca-tee',
    name: "The Creator's Agent Classic Tee",
    collection: 'creators',
    price: 39.00,
    originalPrice: null,
    image: 'https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/awwn1ap4_image_bf7c9544-5aa7-4e27-90e5-eb60d11301d5.png',
    description: 'Combed cotton tee with teal gradient "The Creator\'s Agent" typography. TheCreatorsAgent.com branding.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Midnight Navy', hex: '#141428' }],
    badge: null,
    badgeColor: null,
    rating: 4.7,
    reviews: 156,
    stock: 32,
    category: 'T-Shirts',
  },
  {
    id: 'tca-longsleeve',
    name: "The Creator's Agent Long Sleeve",
    collection: 'creators',
    price: 59.00,
    originalPrice: null,
    image: ASSET('3f11299d-6ec7-49b8-9ad2-73ce78493bf4'),
    description: 'Black long sleeve with compass gear logo, "Build Your Own AI Agent - The Right Way" tagline and TheCreatorsAgent.com branding.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Black', hex: '#111' }],
    badge: null,
    badgeColor: null,
    rating: 4.8,
    reviews: 67,
    stock: 14,
    category: 'Long Sleeves',
  },
  {
    id: 'tca-agent-tee',
    name: '"My Agent\'s Hotter Than Yours" Tee',
    collection: 'creators',
    price: 44.00,
    originalPrice: null,
    image: ASSET('ad300084-6a4a-4c37-ad29-e5953e39bc5b'),
    description: 'Bold statement tee — "My Agent\'s Hotter Than Yours" in gold script. The Creator\'s Agent branding.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: [{ name: 'Black', hex: '#111' }],
    badge: 'TRENDING',
    badgeColor: '#FF00E5',
    rating: 4.9,
    reviews: 145,
    stock: 19,
    category: 'T-Shirts',
  },
];

// Smart recommendation engine - "Complete the Set"
const getRecommendations = (product) => {
  if (!product) return [];
  const recs = PRODUCTS.filter(p => {
    if (p.id === product.id) return false;
    // Same collection, different category = pair well
    if (p.collection === product.collection && p.category !== product.category) return true;
    // Underwear/Swimwear pairings within same collection
    if (p.collection === product.collection && ['Underwear', 'Swimwear'].includes(product.category) && ['Underwear', 'Swimwear'].includes(p.category)) return true;
    return false;
  });
  // Sort by rating descending, take top 3
  return recs.sort((a, b) => b.rating - a.rating).slice(0, 3);
};

// Cart-level recommendations - items not already in cart
const getCartRecommendations = (cartItems) => {
  if (cartItems.length === 0) return [];
  const cartIds = new Set(cartItems.map(i => i.product.id));
  const cartCategories = new Set(cartItems.map(i => i.product.category));
  const cartCollections = new Set(cartItems.map(i => i.product.collection));
  return PRODUCTS.filter(p => {
    if (cartIds.has(p.id)) return false;
    // Complementary: same collection, different category
    if (cartCollections.has(p.collection) && !cartCategories.has(p.category)) return true;
    return false;
  }).sort((a, b) => b.rating - a.rating).slice(0, 2);
};

const TRUST_SIGNALS = [
  { icon: Truck, text: 'Free Shipping on $100+', sub: 'Priority 2-day delivery' },
  { icon: RefreshCw, text: '30-Day Returns', sub: 'No questions asked' },
  { icon: Shield, text: 'Premium Quality', sub: 'Luxury materials guaranteed' },
];

export default function ShopPage() {
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const [collection, setCollection] = useState('all');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const [recentViewers, setRecentViewers] = useState({});

  // Simulate "X people viewing" for social proof
  useEffect(() => {
    const viewers = {};
    PRODUCTS.forEach(p => {
      viewers[p.id] = Math.floor(Math.random() * 15) + 3;
    });
    setRecentViewers(viewers);

    const interval = setInterval(() => {
      setRecentViewers(prev => {
        const updated = { ...prev };
        const keys = Object.keys(updated);
        const key = keys[Math.floor(Math.random() * keys.length)];
        updated[key] = Math.max(2, updated[key] + (Math.random() > 0.5 ? 1 : -1));
        return updated;
      });
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  const filtered = collection === 'all' ? PRODUCTS : PRODUCTS.filter(p => p.collection === collection);

  const addToCart = useCallback((product, size, qty) => {
    setCart(prev => {
      const existing = prev.find(i => i.product.id === product.id && i.size === size);
      if (existing) {
        return prev.map(i => i.product.id === product.id && i.size === size
          ? { ...i, quantity: i.quantity + qty } : i);
      }
      return [...prev, { product, size, quantity: qty }];
    });
    setSelectedProduct(null);
    setSelectedSize('');
    setQuantity(1);
    setShowCart(true);
  }, []);

  const removeFromCart = (productId, size) => {
    setCart(prev => prev.filter(i => !(i.product.id === productId && i.size === size)));
  };

  const cartTotal = cart.reduce((s, i) => s + i.product.price * i.quantity, 0);
  const cartCount = cart.reduce((s, i) => s + i.quantity, 0);

  const toggleWishlist = (productId) => {
    setWishlist(prev => prev.includes(productId) ? prev.filter(id => id !== productId) : [...prev, productId]);
  };

  const handleCheckout = async () => {
    if (!user) { navigate('/auth'); return; }
    try {
      const res = await axios.post(`${API}/shop/checkout`, {
        items: cart.map(i => ({ product_id: i.product.id, size: i.size, quantity: i.quantity, price: i.product.price })),
        origin_url: window.location.origin,
      }, { headers: { Authorization: `Bearer ${token}` } });
      if (res.data.url) window.location.href = res.data.url;
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-texture" data-testid="shop-page">
      {/* Hero Banner */}
      <div className="relative overflow-hidden" style={{ height: '420px' }} data-testid="shop-hero">
        <img src={HERO_BANNER} alt="Smithers XI Collection" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(13,13,13,0.3), rgba(13,13,13,0.95))' }} />
        <div className="absolute bottom-0 left-0 right-0 p-8 max-w-6xl mx-auto">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-3"
            style={{ background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.25)' }}>
            <ShoppingBag size={12} style={{ color: '#D4AF37' }} />
            <span className="font-label" style={{ color: '#D4AF37', fontSize: '10px' }}>OFFICIAL COLLECTION</span>
          </div>
          <h1 className="text-3xl sm:text-5xl font-black leading-tight" style={{ fontFamily: 'Orbitron' }}>
            <span style={{ color: '#D4AF37' }}>SMITHERS XI</span>
            <br />
            <span className="text-white">Official Store</span>
          </h1>
          <p className="text-sm text-gray-400 mt-2 max-w-md">
            Premium apparel and accessories from the Smithers XI and Creator's Agent collections. Limited quantities. Exceptional quality.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Trust Signals */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8 -mt-6 relative z-10" data-testid="trust-signals">
          {TRUST_SIGNALS.map((t, i) => (
            <div key={i} className="ch-card p-4 flex items-center gap-3"
              style={{ borderColor: 'rgba(212,175,55,0.1)' }}>
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ background: 'rgba(212,175,55,0.06)', border: '1px solid rgba(212,175,55,0.12)' }}>
                <t.icon size={18} style={{ color: '#D4AF37' }} />
              </div>
              <div>
                <p className="text-xs font-bold">{t.text}</p>
                <p className="text-[10px] text-[--ch-text-secondary]">{t.sub}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Collection Filters */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex gap-2 overflow-x-auto pb-1">
            {COLLECTIONS.map(c => (
              <button key={c.id} onClick={() => setCollection(c.id)}
                data-testid={`shop-filter-${c.id}`}
                className={`px-5 py-2.5 rounded-full text-xs font-bold whitespace-nowrap transition-all ${
                  collection === c.id
                    ? 'text-black'
                    : 'bg-[--ch-bg-card] text-[--ch-text-secondary] border border-[--ch-border] hover:border-gray-500'
                }`}
                style={collection === c.id ? { background: 'linear-gradient(135deg, #D4AF37, #B8860B)', border: 'none' } : {}}>
                {c.label}
              </button>
            ))}
          </div>
          {/* Cart button */}
          <button onClick={() => setShowCart(true)} data-testid="shop-cart-btn"
            className="relative p-2.5 rounded-lg transition-all hover:bg-[rgba(212,175,55,0.05)]"
            style={{ border: '1px solid rgba(212,175,55,0.15)' }}>
            <ShoppingCart size={18} style={{ color: '#D4AF37' }} />
            {cartCount > 0 && (
              <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full text-[10px] font-bold flex items-center justify-center text-black"
                style={{ background: '#D4AF37' }}>
                {cartCount}
              </span>
            )}
          </button>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="product-grid">
          {filtered.slice(0, 6).map(product => (
            <div key={product.id} className="ch-card overflow-hidden group cursor-pointer"
              onClick={() => { setSelectedProduct(product); setSelectedSize(''); setQuantity(1); }}
              data-testid={`product-${product.id}`}
              style={{ borderColor: 'rgba(212,175,55,0.08)' }}>
              {/* Image */}
              <div className="relative aspect-square overflow-hidden" style={{ background: '#0A0A0A' }}>
                <img src={product.image} alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />

                {/* Badge */}
                {product.badge && (
                  <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full"
                    style={{ background: `${product.badgeColor}20`, border: `1px solid ${product.badgeColor}40` }}>
                    <span className="text-[9px] font-black" style={{ color: product.badgeColor }}>
                      {product.badge}
                    </span>
                  </div>
                )}

                {/* Wishlist */}
                <button
                  data-testid={`wishlist-${product.id}`}
                  onClick={(e) => { e.stopPropagation(); toggleWishlist(product.id); }}
                  className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center transition-all"
                  style={{
                    background: wishlist.includes(product.id) ? 'rgba(255,0,229,0.2)' : 'rgba(0,0,0,0.6)',
                    backdropFilter: 'blur(8px)',
                  }}>
                  <Heart size={14} fill={wishlist.includes(product.id) ? '#FF00E5' : 'none'}
                    className={wishlist.includes(product.id) ? 'text-[--ch-magenta]' : 'text-white'} />
                </button>

                {/* Social proof overlay */}
                <div className="absolute bottom-3 left-3 flex items-center gap-1.5 px-2 py-1 rounded-full"
                  style={{ background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)' }}>
                  <Eye size={10} className="text-gray-400" />
                  <span className="text-[9px] text-gray-300">{recentViewers[product.id] || 5} viewing now</span>
                </div>
              </div>

              {/* Info */}
              <div className="p-4">
                <div className="flex items-center gap-1.5 mb-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={10} fill={i < Math.floor(product.rating) ? '#D4AF37' : 'none'}
                        className={i < Math.floor(product.rating) ? 'text-[#D4AF37]' : 'text-gray-600'} />
                    ))}
                  </div>
                  <span className="text-[10px] text-[--ch-text-secondary]">({product.reviews})</span>
                </div>

                <h3 className="text-sm font-bold mb-1 group-hover:text-[#D4AF37] transition-colors">{product.name}</h3>
                <p className="text-xs text-[--ch-text-secondary] mb-3 line-clamp-2">{product.description}</p>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-lg font-black" style={{ color: '#D4AF37' }}>${product.price}</span>
                    {product.originalPrice && (
                      <span className="text-xs text-[--ch-text-secondary] line-through">${product.originalPrice}</span>
                    )}
                  </div>
                  {product.stock < 15 && (
                    <span className="text-[9px] font-bold flex items-center gap-1 text-[--ch-warning]">
                      <Flame size={10} /> Only {product.stock} left
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Quadra Core Promo Banner */}
        {filtered.length > 6 && (
          <div className="my-8 rounded-2xl overflow-hidden relative cursor-pointer group" data-testid="quadra-core-banner"
            onClick={() => setCollection('smithers')}
            style={{ height: '200px' }}>
            <img src="https://customer-assets.emergentagent.com/job_creator-hub-699/artifacts/l0n3dt2m_image_f45b0310-5aaf-44ae-b684-c972dbfecab1.png"
              alt="SMITHERS XI Quadra Core"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0" style={{ background: 'linear-gradient(90deg, rgba(13,13,13,0.7), transparent)' }} />
            <div className="absolute inset-0 flex items-center p-8">
              <div>
                <p className="font-label text-xs mb-1" style={{ color: '#D4AF37' }}>QUADRA CORE COLLECTION</p>
                <h3 className="text-2xl font-black text-white mb-2" style={{ fontFamily: 'Orbitron' }}>
                  The Premium Line
                </h3>
                <p className="text-xs text-gray-400 max-w-xs">Luxury essentials engineered for those who demand the best.</p>
              </div>
            </div>
          </div>
        )}

        {/* Remaining products */}
        {filtered.length > 6 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="product-grid-2">
            {filtered.slice(6).map(product => (
              <div key={product.id} className="ch-card overflow-hidden group cursor-pointer"
                onClick={() => { setSelectedProduct(product); setSelectedSize(''); setQuantity(1); }}
                data-testid={`product-${product.id}`}
                style={{ borderColor: 'rgba(212,175,55,0.08)' }}>
                <div className="relative aspect-square overflow-hidden" style={{ background: '#0A0A0A' }}>
                  <img src={product.image} alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  {product.badge && (
                    <div className="absolute top-3 left-3 px-2.5 py-1 rounded-full"
                      style={{ background: `${product.badgeColor}20`, border: `1px solid ${product.badgeColor}40` }}>
                      <span className="text-[9px] font-black" style={{ color: product.badgeColor }}>{product.badge}</span>
                    </div>
                  )}
                  <button data-testid={`wishlist-${product.id}`}
                    onClick={(e) => { e.stopPropagation(); toggleWishlist(product.id); }}
                    className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center transition-all"
                    style={{ background: wishlist.includes(product.id) ? 'rgba(255,0,229,0.2)' : 'rgba(0,0,0,0.6)', backdropFilter: 'blur(8px)' }}>
                    <Heart size={14} fill={wishlist.includes(product.id) ? '#FF00E5' : 'none'}
                      className={wishlist.includes(product.id) ? 'text-[--ch-magenta]' : 'text-white'} />
                  </button>
                  <div className="absolute bottom-3 left-3 flex items-center gap-1.5 px-2 py-1 rounded-full"
                    style={{ background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(8px)' }}>
                    <Eye size={10} className="text-gray-400" />
                    <span className="text-[9px] text-gray-300">{recentViewers[product.id] || 5} viewing now</span>
                  </div>
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-1.5 mb-2">
                    <div className="flex items-center">
                      {[...Array(5)].map((_, i) => (
                        <Star key={i} size={10} fill={i < Math.floor(product.rating) ? '#D4AF37' : 'none'}
                          className={i < Math.floor(product.rating) ? 'text-[#D4AF37]' : 'text-gray-600'} />
                      ))}
                    </div>
                    <span className="text-[10px] text-[--ch-text-secondary]">({product.reviews})</span>
                  </div>
                  <h3 className="text-sm font-bold mb-1 group-hover:text-[#D4AF37] transition-colors">{product.name}</h3>
                  <p className="text-xs text-[--ch-text-secondary] mb-3 line-clamp-2">{product.description}</p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="text-lg font-black" style={{ color: '#D4AF37' }}>${product.price}</span>
                      {product.originalPrice && (
                        <span className="text-xs text-[--ch-text-secondary] line-through">${product.originalPrice}</span>
                      )}
                    </div>
                    {product.stock < 15 && (
                      <span className="text-[9px] font-bold flex items-center gap-1 text-[--ch-warning]">
                        <Flame size={10} /> Only {product.stock} left
                      </span>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Product Detail Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 z-[9998] flex items-center justify-center p-4"
          onClick={() => setSelectedProduct(null)}
          style={{ background: 'rgba(0,0,0,0.92)', backdropFilter: 'blur(16px)' }}
          data-testid="product-modal">
          <div onClick={(e) => e.stopPropagation()}
            className="ch-card max-w-2xl w-full relative overflow-hidden max-h-[90vh] overflow-y-auto"
            style={{ animation: 'dropIn 0.3s ease-out', borderColor: 'rgba(212,175,55,0.15)' }}>
            <button onClick={() => setSelectedProduct(null)}
              className="absolute top-4 right-4 z-10 w-8 h-8 rounded-full flex items-center justify-center"
              style={{ background: 'rgba(0,0,0,0.7)' }}>
              <X size={16} className="text-white" />
            </button>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
              {/* Image */}
              <div className="aspect-square overflow-hidden" style={{ background: '#0A0A0A' }}>
                <img src={selectedProduct.image} alt={selectedProduct.name} className="w-full h-full object-cover" />
              </div>

              {/* Details */}
              <div className="p-6 flex flex-col">
                {selectedProduct.badge && (
                  <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full w-fit mb-3"
                    style={{ background: `${selectedProduct.badgeColor}15`, border: `1px solid ${selectedProduct.badgeColor}30` }}>
                    <span className="text-[9px] font-black" style={{ color: selectedProduct.badgeColor }}>
                      {selectedProduct.badge}
                    </span>
                  </div>
                )}

                <h2 className="text-xl font-black mb-1">{selectedProduct.name}</h2>

                <div className="flex items-center gap-2 mb-3">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} size={12} fill={i < Math.floor(selectedProduct.rating) ? '#D4AF37' : 'none'}
                        className={i < Math.floor(selectedProduct.rating) ? 'text-[#D4AF37]' : 'text-gray-600'} />
                    ))}
                  </div>
                  <span className="text-xs text-[--ch-text-secondary]">{selectedProduct.rating} ({selectedProduct.reviews} reviews)</span>
                </div>

                <div className="flex items-center gap-3 mb-4">
                  <span className="text-2xl font-black" style={{ color: '#D4AF37' }}>${selectedProduct.price}</span>
                  {selectedProduct.originalPrice && (
                    <>
                      <span className="text-sm text-[--ch-text-secondary] line-through">${selectedProduct.originalPrice}</span>
                      <span className="text-xs px-2 py-0.5 rounded-full font-bold"
                        style={{ background: 'rgba(34,197,94,0.1)', color: '#22C55E' }}>
                        SAVE ${(selectedProduct.originalPrice - selectedProduct.price).toFixed(0)}
                      </span>
                    </>
                  )}
                </div>

                <p className="text-sm text-[--ch-text-secondary] mb-4">{selectedProduct.description}</p>

                {/* Size Selector */}
                <div className="mb-4">
                  <label className="font-label text-[--ch-text-secondary] mb-2 block text-xs">SELECT SIZE</label>
                  <div className="flex gap-2 flex-wrap">
                    {selectedProduct.sizes.map(size => (
                      <button key={size} onClick={() => setSelectedSize(size)}
                        data-testid={`size-${size}`}
                        className={`w-11 h-11 rounded-lg text-xs font-bold transition-all ${
                          selectedSize === size
                            ? 'text-black'
                            : 'bg-[--ch-bg-secondary] text-[--ch-text-secondary] border border-[--ch-border] hover:border-gray-500'
                        }`}
                        style={selectedSize === size ? { background: '#D4AF37', border: 'none' } : {}}>
                        {size}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Quantity */}
                <div className="mb-5">
                  <label className="font-label text-[--ch-text-secondary] mb-2 block text-xs">QUANTITY</label>
                  <div className="flex items-center gap-3">
                    <button onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      className="w-9 h-9 rounded-lg flex items-center justify-center bg-[--ch-bg-secondary] border border-[--ch-border] hover:border-gray-500 transition-colors">
                      <Minus size={14} className="text-white" />
                    </button>
                    <span className="text-sm font-bold w-8 text-center">{quantity}</span>
                    <button onClick={() => setQuantity(Math.min(10, quantity + 1))}
                      className="w-9 h-9 rounded-lg flex items-center justify-center bg-[--ch-bg-secondary] border border-[--ch-border] hover:border-gray-500 transition-colors">
                      <Plus size={14} className="text-white" />
                    </button>
                  </div>
                </div>

                {/* Urgency */}
                {selectedProduct.stock < 15 && (
                  <div className="p-3 rounded-lg mb-4 flex items-center gap-2"
                    style={{ background: 'rgba(245,158,11,0.05)', border: '1px solid rgba(245,158,11,0.12)' }}>
                    <Clock size={13} className="text-[--ch-warning] flex-shrink-0" />
                    <p className="text-[11px] text-[--ch-warning]">
                      <strong>Hurry!</strong> Only {selectedProduct.stock} left in stock.
                      {recentViewers[selectedProduct.id] > 5 && ` ${recentViewers[selectedProduct.id]} people are viewing this right now.`}
                    </p>
                  </div>
                )}

                {/* Add to Cart */}
                <button
                  data-testid="add-to-cart-btn"
                  onClick={() => {
                    if (!selectedSize) return;
                    addToCart(selectedProduct, selectedSize, quantity);
                  }}
                  disabled={!selectedSize}
                  className="w-full py-4 rounded-full text-sm font-black flex items-center justify-center gap-2 transition-all disabled:opacity-30 disabled:cursor-not-allowed"
                  style={{
                    background: selectedSize ? 'linear-gradient(135deg, #D4AF37, #B8860B)' : undefined,
                    color: selectedSize ? '#000' : undefined,
                    boxShadow: selectedSize ? '0 0 20px rgba(212,175,55,0.3)' : 'none',
                  }}>
                  <ShoppingBag size={16} />
                  {selectedSize ? `ADD TO BAG — $${(selectedProduct.price * quantity).toFixed(2)}` : 'SELECT A SIZE'}
                </button>

                {/* Trust */}
                <div className="mt-4 space-y-1.5">
                  {[
                    { icon: Truck, text: 'Free shipping on orders $100+' },
                    { icon: RefreshCw, text: '30-day hassle-free returns' },
                    { icon: Shield, text: 'Authentic SMITHERS XI product' },
                  ].map((t, i) => (
                    <div key={i} className="flex items-center gap-2">
                      <t.icon size={11} className="text-[--ch-text-secondary]" />
                      <span className="text-[10px] text-[--ch-text-secondary]">{t.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Complete the Set - Cross-sell */}
            {getRecommendations(selectedProduct).length > 0 && (
              <div className="p-5 border-t" style={{ borderColor: 'rgba(212,175,55,0.08)' }} data-testid="complete-the-set">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-1 h-4 rounded-full" style={{ background: '#D4AF37' }} />
                  <h4 className="text-xs font-black" style={{ fontFamily: 'Orbitron', color: '#D4AF37' }}>COMPLETE THE SET</h4>
                </div>
                <div className="grid grid-cols-3 gap-3">
                  {getRecommendations(selectedProduct).map(rec => (
                    <div key={rec.id}
                      className="cursor-pointer group/rec rounded-xl overflow-hidden transition-all hover:ring-1"
                      style={{ background: 'rgba(20,20,20,0.5)', border: '1px solid rgba(212,175,55,0.06)', '--tw-ring-color': 'rgba(212,175,55,0.3)' }}
                      onClick={() => { setSelectedProduct(rec); setSelectedSize(''); setQuantity(1); }}
                      data-testid={`rec-${rec.id}`}>
                      <div className="aspect-square overflow-hidden" style={{ background: '#0A0A0A' }}>
                        <img src={rec.image} alt={rec.name} className="w-full h-full object-cover group-hover/rec:scale-105 transition-transform duration-300" />
                      </div>
                      <div className="p-2.5">
                        <p className="text-[10px] font-bold truncate group-hover/rec:text-[#D4AF37] transition-colors">{rec.name}</p>
                        <p className="text-xs font-black mt-1" style={{ color: '#D4AF37' }}>${rec.price}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Cart Slide-over */}
      {showCart && (
        <div className="fixed inset-0 z-[9999]" onClick={() => setShowCart(false)} data-testid="cart-panel">
          <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.8)' }} />
          <div onClick={(e) => e.stopPropagation()}
            className="absolute top-0 right-0 bottom-0 w-full max-w-md flex flex-col"
            style={{
              background: 'rgba(13,13,13,0.98)',
              backdropFilter: 'blur(20px)',
              borderLeft: '1px solid rgba(212,175,55,0.1)',
              animation: 'slideInRight 0.3s ease-out',
            }}>
            {/* Cart Header */}
            <div className="p-5 border-b flex items-center justify-between"
              style={{ borderColor: 'rgba(212,175,55,0.1)' }}>
              <div className="flex items-center gap-2">
                <ShoppingBag size={18} style={{ color: '#D4AF37' }} />
                <h3 className="text-sm font-black" style={{ fontFamily: 'Orbitron', color: '#D4AF37' }}>YOUR BAG</h3>
                <span className="text-xs text-[--ch-text-secondary]">({cartCount} items)</span>
              </div>
              <button onClick={() => setShowCart(false)}
                className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-[rgba(255,255,255,0.05)]">
                <X size={16} className="text-gray-400" />
              </button>
            </div>

            {/* Cart Items */}
            <div className="flex-1 overflow-y-auto p-5 space-y-4">
              {cart.length === 0 ? (
                <div className="text-center py-12">
                  <ShoppingBag size={36} className="text-gray-700 mx-auto mb-3" />
                  <p className="text-sm text-[--ch-text-secondary]">Your bag is empty</p>
                  <button onClick={() => setShowCart(false)}
                    className="mt-4 px-6 py-2.5 rounded-full text-xs font-bold"
                    style={{ border: '1px solid rgba(212,175,55,0.3)', color: '#D4AF37' }}>
                    Continue Shopping
                  </button>
                </div>
              ) : cart.map((item, i) => (
                <div key={i} className="flex gap-3 p-3 rounded-xl"
                  style={{ background: 'rgba(20,20,20,0.5)', border: '1px solid rgba(212,175,55,0.06)' }}
                  data-testid={`cart-item-${i}`}>
                  <div className="w-20 h-20 rounded-lg overflow-hidden flex-shrink-0" style={{ background: '#0A0A0A' }}>
                    <img src={item.product.image} alt={item.product.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-xs font-bold truncate">{item.product.name}</h4>
                    <p className="text-[10px] text-[--ch-text-secondary]">Size: {item.size} | Qty: {item.quantity}</p>
                    <p className="text-sm font-bold mt-1" style={{ color: '#D4AF37' }}>
                      ${(item.product.price * item.quantity).toFixed(2)}
                    </p>
                  </div>
                  <button onClick={() => removeFromCart(item.product.id, item.size)}
                    className="p-1.5 rounded-lg hover:bg-[rgba(255,0,0,0.05)] transition-colors self-start">
                    <X size={14} className="text-gray-500" />
                  </button>
                </div>
              ))}
            </div>

            {/* Cart Footer */}
            {cart.length > 0 && (
              <div className="p-5 border-t" style={{ borderColor: 'rgba(212,175,55,0.1)' }}>
                {/* Frequently Bought Together */}
                {getCartRecommendations(cart).length > 0 && (
                  <div className="mb-4 p-3 rounded-xl" style={{ background: 'rgba(212,175,55,0.03)', border: '1px solid rgba(212,175,55,0.08)' }}
                    data-testid="cart-recommendations">
                    <p className="text-[9px] font-black mb-2.5" style={{ fontFamily: 'Orbitron', color: '#D4AF37', letterSpacing: '1px' }}>PAIRS WELL WITH</p>
                    <div className="space-y-2">
                      {getCartRecommendations(cart).map(rec => (
                        <div key={rec.id} className="flex items-center gap-2.5">
                          <div className="w-10 h-10 rounded-lg overflow-hidden flex-shrink-0" style={{ background: '#0A0A0A' }}>
                            <img src={rec.image} alt={rec.name} className="w-full h-full object-cover" />
                          </div>
                          <div className="flex-1 min-w-0">
                            <p className="text-[10px] font-bold truncate">{rec.name}</p>
                            <p className="text-[10px] font-black" style={{ color: '#D4AF37' }}>${rec.price}</p>
                          </div>
                          <button
                            data-testid={`quick-add-${rec.id}`}
                            onClick={() => addToCart(rec, rec.sizes[1] || rec.sizes[0], 1)}
                            className="px-2.5 py-1 rounded-full text-[9px] font-black transition-all hover:opacity-80"
                            style={{ background: 'rgba(212,175,55,0.15)', color: '#D4AF37', border: '1px solid rgba(212,175,55,0.25)' }}>
                            + ADD
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {cartTotal >= 100 && (
                  <div className="flex items-center gap-2 mb-3 p-2.5 rounded-lg"
                    style={{ background: 'rgba(34,197,94,0.05)', border: '1px solid rgba(34,197,94,0.1)' }}>
                    <Check size={12} className="text-[--ch-success]" />
                    <span className="text-[10px] text-[--ch-success] font-bold">Free shipping unlocked!</span>
                  </div>
                )}
                <div className="flex items-center justify-between mb-4">
                  <span className="text-sm text-[--ch-text-secondary]">Subtotal</span>
                  <span className="text-xl font-black" style={{ color: '#D4AF37' }}>${cartTotal.toFixed(2)}</span>
                </div>
                <button onClick={handleCheckout} data-testid="checkout-btn"
                  className="w-full py-4 rounded-full text-sm font-black flex items-center justify-center gap-2"
                  style={{ background: 'linear-gradient(135deg, #D4AF37, #B8860B)', color: '#000', boxShadow: '0 0 20px rgba(212,175,55,0.3)' }}>
                  <ShoppingBag size={16} /> CHECKOUT <ArrowRight size={14} />
                </button>
                <p className="text-center text-[10px] text-[--ch-text-secondary] mt-3">
                  Secure checkout powered by Stripe
                </p>
              </div>
            )}
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideInRight {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
}
